import { render, staticRenderFns } from "./configurations.vue?vue&type=template&id=5266e54c&"
import script from "./configurations.vue?vue&type=script&lang=js&"
export * from "./configurations.vue?vue&type=script&lang=js&"
import style0 from "./configurations.vue?vue&type=style&index=0&id=5266e54c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports